import { useEffect, useState } from 'react';
import { getTotalCandidatesFromTalentPool } from 'wisestep-api';

import CustomCountWithTextCard from './CustomCountWithTextCard';

const TotalCandidates = ({ workspaceId }: { workspaceId: string }) => {
  const [totalCandidates, setTotalCandidates] = useState<number>(0);
  useEffect(() => {
    const fetchData = async () => {
      const response = await getTotalCandidatesFromTalentPool(workspaceId);
      setTotalCandidates(response.data);
    };
    fetchData();
  }, [workspaceId]);

  return (
    <CustomCountWithTextCard count={totalCandidates} text="Candidates in TalentPool- Life Time" />
  );
};

export default TotalCandidates;
